<template>
  <Modal :title="'Dodeli nalog'" @close="$emit('close')">
    <div class="row">
      <div class="col-lg-3">
        <h6>
          {{ orderForAssignment?.orderNumber }} <small class="text-muted">{{ orderForAssignment?.subject }}</small>
        </h6>
        <h4>{{ orderForAssignment?.facilityName }}</h4>
      </div>
      <div class="col-lg-9">
        <NearbyServiceOrders ref="nearbyOrders" :centerOrder="orderForAssignment" />
      </div>
    </div>
    <hr />
    <WorkersWithWorkOrdersCard
      title=""
      v-if="!!orderForAssignment"
      :showLoggedTime="false"
      :orderForAssignment="orderForAssignment"
      @selected="assignOrders"
    />
  </Modal>
</template>

<script setup>
import { ref } from "vue"
import { useAuth } from "../composition-api/useAuth"
import WorkersWithWorkOrdersCard from "../components/WorkersWithWorkOrdersCard.vue"
import NearbyServiceOrders from "../components/NearbyServiceOrders.vue"
import { setSuccess } from "../components/Notification"
import { assignOrderAsync } from "../api"

defineOptions({ name: "ModalAssignWorkOrder" })

const props = defineProps({
  orderForAssignment: {
    type: Object,
    default: null,
  },
})

const emit = defineEmits(["close", "assigned"])

const { fetchAuthAsync } = useAuth()
const nearbyOrders = ref(null)

const assignOrders = async (workerId) => {
  let success = 0
  const selectedOrders = (nearbyOrders.value?.orders ?? []).filter((o) => o.selected)
  await Promise.all(
    selectedOrders.map(async (o) => {
      const result = await assignOrderAsync(fetchAuthAsync, workerId, o.id)
      if (result) {
        success++
      }
    }),
  )
  if (success > 0) {
    emit("close")
    emit("assigned")
    setSuccess("Nalogi dodeljeni. " + success + " nalogov.")
  } else {
    console.log("No orders assigned.")
  }
}
</script>
